import { useState, useEffect } from "react";

export type ViewSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export function useViewSize(): ViewSize {
  const [viewSize, setViewSize] = useState<ViewSize>("lg");

  useEffect(() => {
    const updateViewSize = () => {
      const width = window.innerWidth;
      if (width < BREAKPOINTS.sm) {
        setViewSize("xs");
      } else if (width < BREAKPOINTS.md) {
        setViewSize("sm");
      } else if (width < BREAKPOINTS.lg) {
        setViewSize("md");
      } else if (width < BREAKPOINTS.xl) {
        setViewSize("lg");
      } else if (width < BREAKPOINTS["2xl"]) {
        setViewSize("xl");
      } else {
        setViewSize("2xl");
      }
    };

    updateViewSize();
    window.addEventListener("resize", updateViewSize);
    return () => window.removeEventListener("resize", updateViewSize);
  }, []);

  return viewSize;
}

export function isSmallOrMedium(size: ViewSize): boolean {
  return size === "xs" || size === "sm" || size === "md";
}

// Returns true when sidebar is hidden (below md breakpoint)
export function isSidebarHidden(size: ViewSize): boolean {
  return size === "xs" || size === "sm";
}
